import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, center, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
        {title}
      </h2>
      {subtitle && <p className="mt-5 text-base lg:text-lg text-ink-muted leading-relaxed font-sans">{subtitle}</p>}
    </div>
  );
}
